export class PaymentIntent {
  constructor(
    public readonly id: string,
    public readonly secret: string,
  ) {
  }
}